import { lastValueFrom } from 'rxjs';
import { Component } from '@angular/core';
import { AccountService } from '../account.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditConfigModalComponent } from './edit-config/edit-config.modal.component';

@Component({
  selector: 'app-view-account',
  templateUrl: './view-account.component.html',
  styleUrls: ['./view-account.component.scss'],
})
export class ViewAccountComponent {
  public account: any;
  public accountTaxes: any;
  public selected: number = 0;

  public isLoaded: boolean = true;
  public validationCode: string = '';
  public errorMessage: string = '';
  public idCopy: string = '';
  public rotatingApiToken = false;
  public rotatingGameToken = false;
  constructor(
    private accountService: AccountService,
    public authService: AuthService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) {
    this.accountService
      .getAccount()
      .then((value) => {
        this.account = value;
      })
      .then(() => {
        this.selected = this.account.personType == 0 ? 1 : 2;
      });

    this.accountService.getAccountTaxes().then((value) => {
      this.accountTaxes = value;
    });
  }

  openEditConfigModal() {
    const modalRef = this.modalService.open(EditConfigModalComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'modal-wide',
      backdrop: 'static',
      keyboard: true,
    });

    const withdraw = this.account?.withDrawConfiguration ?? {};
    const deposit = this.account?.depositConfiguration ?? {};

    modalRef.componentInstance.account = {
      // raiz
      listsIp: this.account?.listsIp ?? [],
      featureFlagRefundPix: this.account?.featureFlagRefundPix ?? false,
      featureFlagCpfWithdraw: this.account?.featureFlagCpfWithdraw ?? false,

      // saque (withDrawConfiguration)
      valorMinimoSaqueAutomatico: withdraw?.valorMinimoSaqueAutomatico ?? 0,
      amountExpired: withdraw?.amountExpired ?? 0,
      valueExpired: withdraw?.valueExpired ?? 0,
      analyzeWithdrawal: withdraw?.analyzeWithdrawal ?? false,
      valueMinRequest: withdraw?.valueMinRequest ?? 0,
      valueMaxRequest: withdraw?.valueMaxRequest ?? 0,

      // depósito (depositConfiguration)
      depositValueMinRequest: deposit?.valueMinRequest ?? 0,
      depositValueMaxRequest: deposit?.valueMaxRequest ?? 0,
    };

    modalRef.result
      .then((result) => {
        if (result === 'saved') {
          this.accountService.getAccount().then((value) => {
            this.account = value;
          });
        }
      })
      .catch(() => {});
  }

  copyId(id: string): void {
    if (!id) {
      this.toastr.warning('Não há nada para copiar', 'Aviso', {
        timeOut: 2000,
        positionClass: 'toast-top-right',
      });
      return;
    }

    navigator.clipboard
      .writeText(id)
      .then(() => {
        this.toastr.success('Copiado com sucesso!', 'Sucesso', {
          timeOut: 2000,
          positionClass: 'toast-top-right',
        });
      })
      .catch(() => {
        this.toastr.error('Erro ao copiar', 'Erro', {
          timeOut: 2000,
          positionClass: 'toast-top-right',
        });
      });
  }

  rotateApiToken(): void {
    this.rotatingApiToken = true;
    this.accountService.rotateKeyToken(false).subscribe({
      next: () => {
        this.toastr.success('Credenciais de acesso API rotacionadas com sucesso!', 'Sucesso');
        this.accountService.getAccount().then((value) => (this.account = value));
      },
      error: (err) => {
        const msg = err?.error?.mensagem || 'Erro ao rotacionar credenciais.';
        this.toastr.error(msg, 'Erro');
      },
      complete: () => (this.rotatingApiToken = false),
    });
  }

  rotateGameToken(): void {
    this.rotatingGameToken = true;
    this.accountService.rotateKeyToken(true).subscribe({
      next: () => {
        this.toastr.success('Credenciais de API para jogos rotacionadas com sucesso!', 'Sucesso');
        this.accountService.getAccount().then((value) => (this.account = value));
      },
      error: (err) => {
        const msg = err?.error?.mensagem || 'Erro ao rotacionar credenciais.';
        this.toastr.error(msg, 'Erro');
      },
      complete: () => (this.rotatingGameToken = false),
    });
  }

  async isValidTotp() {
    let isValid: boolean = false;
    await this.authService
      .validateTotpCode(this.validationCode)
      .then((value) => {
        isValid = value.isValid;
      });
    return isValid;
  }

  async validateTotp() {
    this.isLoaded = false;
    let isValidTotp = await this.isValidTotp();

    if (isValidTotp) {
      this.modalService.dismissAll();

      await lastValueFrom(
        this.accountService.setWithdrawAutomatic(
          !this.account.withDrawConfiguration.isAutomatic,
        ),
      ).then(() => {
        this.accountService
          .getAccount()
          .then((value) => {
            this.account = value;
          })
          .then(() => {
            this.selected = this.account.personType == 0 ? 1 : 2;
          });

        this.accountService.getAccountTaxes().then((value) => {
          this.accountTaxes = value;
        });

        this.toastr.success('Operação realizada com sucesso!', 'Sucesso!', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      });
    } else {
      this.errorMessage = 'Código de autenticação inválido!';
    }

    this.isLoaded = true;
  }
}
